<top-navig [display]="true" [displayLogo]="false" title="Récupération"></top-navig>
<div class="div-bag"></div>
<div class="omber"></div>
<div class="forgetPassword" [class.mt-110]="ourApp">
    <div class="text-center logo">
        <img src="assets/images/logo.png" alt="logo" width="130px">
    </div>
    <!-- <h1 class="text-center">Récupérer mon mot de passe</h1> -->
    <form>
        <div id="u" class="form-group">
            <div class="inner-addon left-addon">
                <i class="glyphicon flaticon-gmail-logo pull-right"></i>
                <input spellcheck=false class="form-control" [(ngModel)]="email" name="username" type="text" size="18"
                    alt="login" required>
                <span class="form-highlight"></span>
                <span class="form-bar"></span>
                <label for="username" class="float-label">Email</label>
            </div>
        </div>
        <p>
            Merci de consulter votre boite e-mail pour obtenir votre mot de passe.
        </p>
        <div class="form-group text-right">
            <table width="100%">
                <tr>
                    <td class="text-right td-conn">
                        <a routerLink="/compte/connexion" class="login-btn">
                            Se connecter &nbsp;&nbsp;
                            <i class="glyphicon glyphicon-arrow-right"></i>
                        </a>
                    </td>
                </tr>
            </table>
        </div>
        <div class="text-center validate" [ngClass]="{'inLoading':loader}">
            <button (click)="send()" [disabled]="loader">
                <span *ngIf="!loader">Envoyer</span>
            </button>
            <div *ngIf="loader" id="loadingPage"></div>
        </div>
    </form>
</div>